import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _div;
var _excluded = ["prompt", "onPromptChange", "className", "rows", "placeholder", "onSubmit", "customPlaceholders", "onScrollActiveChange", "variant", "fixedHeight"];
import { useCallback, useEffect, useRef, useState } from 'react';
import { cn } from '@crehana/compass.ui/v2';
import { useTypewriter } from "../hooks/use-typewritter";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var HanaPromptTextareaV2 = function HanaPromptTextareaV2(_ref) {
  var prompt = _ref.prompt,
    onPromptChange = _ref.onPromptChange,
    className = _ref.className,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 1 : _ref$rows,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    onSubmit = _ref.onSubmit,
    customPlaceholders = _ref.customPlaceholders,
    onScrollActiveChange = _ref.onScrollActiveChange,
    variant = _ref.variant,
    _ref$fixedHeight = _ref.fixedHeight,
    fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(placeholder),
    _useState2 = _slicedToArray(_useState, 2),
    customsPlaceholder = _useState2[0],
    setCustomsPlaceholder = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isScrollActive = _useState4[0],
    setIsScrollActive = _useState4[1];
  var textAreaRef = useRef(null);
  var displayPlaceholderText = useTypewriter(customsPlaceholder, 15, false);

  // Sync placeholder state when prop changes
  useEffect(function () {
    if (!customPlaceholders || customPlaceholders.length === 0) {
      setCustomsPlaceholder(placeholder);
    }
  }, [placeholder, customPlaceholders]);

  // Función para detectar si el scroll está activo
  var checkScrollActive = useCallback(function () {
    if (textAreaRef.current) {
      var _textAreaRef$current = textAreaRef.current,
        scrollHeight = _textAreaRef$current.scrollHeight,
        clientHeight = _textAreaRef$current.clientHeight;
      var hasScroll = scrollHeight > clientHeight;
      if (hasScroll !== isScrollActive) {
        setIsScrollActive(hasScroll);
        onScrollActiveChange === null || onScrollActiveChange === void 0 ? void 0 : onScrollActiveChange(hasScroll);
      }
    }
  }, [isScrollActive, onScrollActiveChange]);

  // Detectar cambios en el scroll cuando cambia el contenido
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    checkScrollActive();
  }, [prompt, checkScrollActive]);

  // Auto-resize del textarea cuando cambia el contenido (solo si no hay altura fija)
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (textAreaRef.current && !fixedHeight) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = "".concat(textAreaRef.current.scrollHeight, "px");
    }
  }, [prompt, fixedHeight]);

  // This useEffect is necessary to create a dynamic and engaging experience
  // in the textarea, automatically rotating between different custom placeholders
  // every 4 seconds to maintain user attention
  useEffect(function () {
    // Set up an interval that runs every 4000ms (4 seconds)
    var interval = setInterval(function () {
      // Check that custom placeholders exist and there's at least one
      if (customPlaceholders && customPlaceholders.length > 0) {
        // Generate a random index to select a different placeholder
        // on each rotation, creating variety in the user experience
        var randomIndex = Math.floor(Math.random() * customPlaceholders.length);
        // Update the state with the newly selected placeholder
        setCustomsPlaceholder(customPlaceholders[randomIndex]);
      }
    }, 4000);

    // It's crucial to clean up the interval when the component unmounts
    // to prevent memory leaks and unexpected behaviors
    return function () {
      return clearInterval(interval);
    };
  }, [customPlaceholders]);
  var onKeyDown = function onKeyDown(e) {
    if ((e === null || e === void 0 ? void 0 : e.key) === 'Enter' && !e.shiftKey) {
      var _textAreaRef$current2;
      e.preventDefault();
      onSubmit();
      if ((_textAreaRef$current2 = textAreaRef.current) !== null && _textAreaRef$current2 !== void 0 && _textAreaRef$current2.style && !fixedHeight) {
        textAreaRef.current.style.height = 'auto';
      }
      return;
    }
  };
  var handleScroll = function handleScroll() {
    checkScrollActive();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-relative tw-w-full",
    children: [/*#__PURE__*/_jsx("textarea", _objectSpread({
      name: "prompt",
      className: cn('tw-text-neutral-light-800 tw-resize-none tw-w-full tw-font-body3 tw-outline-none tw-max-h-16 tw-leading-2.2', {
        'tw-pb-2': isScrollActive
      }, className),
      placeholder: customPlaceholders ? displayPlaceholderText : placeholder,
      value: prompt,
      onChange: onPromptChange,
      onKeyDown: onKeyDown,
      onScroll: handleScroll,
      rows: rows,
      ref: textAreaRef
    }, props)), isScrollActive && (_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-h-4 tw-bg-gradient-to-t tw-from-neutral-light-100 tw-to-transparent tw-pointer-events-none"
    })))]
  });
};